import { StringUnionKeyAsValue } from '../helpers/TypescriptHelpers';
import { ExploreContentApi_ContentType } from '../ServerApi/types/IContent';
import { IExplorableItemTypeInfo } from './resourceInfoParts';


/**
 * These are the item types that can be browsed in an Explorer.
 * Includes the "primary" content types (from the exploreContent API) and also non-content
 * entities that can be browsed (e.g. subscriptions, refresh extracts).
 */
export type ExplorableItemType = ExploreContentApi_ContentType
    | 'subscription'
    | 'connection'
    | 'extractTask'
    | 'remoteRefreshSchedule'
    | 'connectedWorkbook'
    | 'flowOutputStepRun'
    | 'backgroundJob'
    | 'metric'
    | 'siteuser'
    | 'serveruser'
    | 'recommendedView'
    | 'dataalert'
    | 'site'
    | 'schedule'
    | 'runFlowTask'
  ;

/**
 * These are the entity types that have their own landing pages ("space page").
 * These content types and explorable items, so their names should match where possible.
 */
export type SpaceInfoItemType = 'project' | 'schedule' | 'workbook' | 'view' | 'datasource' | 'flow' | 'dataRole' | 'group' | 'siteuser'| 'serveruser' | 'metric';

export const SpaceInfoItemTypeValue: StringUnionKeyAsValue<SpaceInfoItemType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  dataRole: 'dataRole',
  group: 'group',
  siteuser: 'siteuser',
  serveruser: 'serveruser',
  schedule: 'schedule',
  metric: 'metric',
};

export function isSpaceInfoItemType(itemType: string): itemType is SpaceInfoItemType {
  return SpaceInfoItemTypeValue.hasOwnProperty(itemType);
}

export function isRecommendationType(itemType: ExplorableItemType): itemType is ExplorableItemType {
  const recommendationTypes = ['recommendedView'];
  return itemType && recommendationTypes.includes(itemType);
}

export function getKeyForExplorableItem(item: IExplorableItemTypeInfo): string {
  return `${item.contentType}_${item.id}`;
}
